import { useMemo } from "react";
import { useMapLayer } from "../hooks/useMapLayer";
import DroneObject from "../objects/DroneObject";
import type { DroneMapObject, MapLayerProps } from "../types";

type DronesLayerProps = MapLayerProps<DroneMapObject>;

const DronesLayer = ({
    id,
    items,
    selectedIds,
    onItemClick,
    onItemHover,
    onItemLeave,
}: DronesLayerProps) => {
    const { items: layerItems } = useMapLayer({ items, selectedIds });
    const orderedItems = useMemo(
        () => [
            ...layerItems.filter((item) => !item.isOnline),
            ...layerItems.filter((item) => item.isOnline),
        ],
        [layerItems],
    );
    const baseObjects = useMemo(
        () =>
            orderedItems.map((item) => (
                <DroneObject
                    key={item.id}
                    item={item}
                    layerId={id}
                    selected={selectedIds?.has(item.id) ?? false}
                    onItemClick={onItemClick}
                    onItemHover={onItemHover}
                    onItemLeave={onItemLeave}
                />
            )),
        [id, onItemClick, onItemHover, onItemLeave, orderedItems, selectedIds],
    );

    return <pixiContainer label="drones-layer">{baseObjects}</pixiContainer>;
};

export default DronesLayer;
